import classNames from "classnames";
import "./BFDivider.scss";

interface BFDividerProps {
  vertical?: boolean;
}
const BFDivider = (props: BFDividerProps) => {
  return (
    <div
      className={classNames(`bf-divider`, {
        vertical: props.vertical,
        horizontal: !props.vertical,
      })}
    />
  );
};

export default BFDivider;
